import { useState } from "react";
import classNames from "classnames";
import { Icon } from "@/comn/components";

export const TaneswPortalMainCargoTracking = () => {
    const [cargoType, setCargoType] = useState("CRN");
    const [searchTerm, setSearchTerm] = useState("");

    const handleRadioChange = (e: any) => {
        setCargoType(e.target.value);
    };

    const handleInputChange = (e: any) => {
        setSearchTerm(e.target.value);
    };

    const handleSearch = () => {
        const hostUrl = process.env.REACT_APP_API_FRONT_CGME;

        const url = `${hostUrl}/cgme/trkng/cgme0910001q?menuId=menu_cgme0711&cargoType=${cargoType}&searchTerm=${searchTerm}`;

        window.location.href = url;
    };

    return (
        <div className="w-full flex items-center px-4 bg-header h-16 lg:w-fit rounded-full gap-6 sm:mt-10 relative">
            <div className="flex items-center gap-2 ml-2 text-primary-text sm:absolute sm:left-0 sm:top-0 sm:-translate-y-10">
                <Icon icon="tracking" />
                <span className="text-lg font-semibold">Cargo tracking</span>
            </div>

            <div className="w-[1px] h-10 bg-border sm:hidden" />

            <div className="flex items-center gap-4">
                <label className="flex items-center gap-1">
                    <input type="radio" value="CRN" checked={cargoType === "CRN"} onChange={handleRadioChange} />
                    CRN
                </label>
                <label className="flex items-center gap-1">
                    <input type="radio" value="BL" checked={cargoType === "BL"} onChange={handleRadioChange} />
                    B/L(AWB)
                </label>
            </div>

            <div className="w-[1px] h-10 bg-border" />

            <div className="flex-1">
                <input
                    className="lg:w-96 w-full bg-header outline-none h-8"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={handleInputChange}
                />
            </div>

            <button
                className="rounded-full bg-primary h-10 min-w-10 flex items-center justify-center"
                onClick={handleSearch}
            >
                <Icon icon="search" className="text-primary-contrast"></Icon>
            </button>
        </div>
    );
};
